import { createStore, get, set, del } from 'idb-keyval';

// create your own store instance
const myStore = createStore('app-db', 'json-store');

// set with expiry
async function idbSetWithExpiry(key, value, ttlMillis) {
    const record = { value, expiry: Date.now() + ttlMillis };
    await set(key, record, myStore);
}

// get with expiry
async function idbGetWithExpiry(key) {
    const record = await get(key, myStore);
    if (!record) return null;
    if (Date.now() > record.expiry) {
        await del(key, myStore);
        return null;
    }
    return record.value;
}

export { idbSetWithExpiry, idbGetWithExpiry };
